// Theme: light | dark | system (per device). Applies the `dark` class on <html>.
const KEY = "osc_theme";
const mq = () => (typeof window !== "undefined" && window.matchMedia ? window.matchMedia("(prefers-color-scheme: dark)") : null);

export const getTheme = () => { try { return localStorage.getItem(KEY) || "light"; } catch (e) { return "light"; } };

export function applyTheme(mode = getTheme()) {
  const dark = mode === "dark" || (mode === "system" && !!mq()?.matches);
  document.documentElement.classList.toggle("dark", dark);
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute("content", dark ? "#0f141c" : "#ffffff");
}

export function setTheme(mode) {
  try { localStorage.setItem(KEY, mode); } catch (e) { /* ignore */ }
  applyTheme(mode);
}

export function initTheme() {
  applyTheme();
  mq()?.addEventListener?.("change", () => { if (getTheme() === "system") applyTheme("system"); });
}
